import React from 'react';
import styled from 'styled-components';

import { caption2Font, body2Font } from '../Typography/Typography';

const Title = styled.h3`
  color: rgb(51, 51, 51);
  ${body2Font}
  font-weight: normal;
  margin: 0 0 2px 0;
`;

const SubTitle = styled.div`
  color: rgb(102, 102, 102);
  ${caption2Font}
  margin: 0 0 2px 0;
`;

export interface IInfoProps {
  title?: string;
  subtitle?: string;
}

export const PeopleDetailHighlightsInfo: React.FunctionComponent<IInfoProps> = props => {
  const { title, subtitle } = props;
  return (
    <div>
      <Title className="highlight-on-card-hover">{title}</Title>
      <SubTitle key={subtitle}>{subtitle}</SubTitle>
    </div>
  );
};

export default PeopleDetailHighlightsInfo;
